// // // src/components/Sidebar.js
// // import React from 'react';
// // import { Menu, MenuItem, ProSidebar, SubMenu } from 'react-pro-sidebar';
// // import { Link } from 'react-router-dom';

// // // Menu data structure
// // const menuItems = [
// //   { to: '/', label: 'Home' },
// //   {
// //     title: 'Entities',
// //     items: [
// //       { to: '/entities', label: 'Entities' },
// //       { to: '/events', label: 'Events' },
// //       { to: '/event-sections', label: 'Event Sections' },
// //     ],
// //   },
// //   {
// //     title: 'Stations',
// //     items: [
// //       { to: '/station-types', label: 'Station Types' },
// //       { to: '/stations', label: 'Stations' },
// //     ],
// //   },
// //   { to: '/users', label: 'Users' },
// //   { to: '/roles', label: 'Roles' },
// //   { to: '/permissions', label: 'Permissions' },
// //   { to: '-role-events', label: 'User Role Events' },
// //   {
// //     title: 'Items',
// //     items: [
// //       { to: '/items-type', label: 'Item Types' },
// //       { to: '/items', label: 'Items' },
// //       { to: '/item-deliveries', label: 'Item Deliveries' },
// //       { to: '/item-delivery-logs', label: 'Item Delivery Logs' },
// //     ],
// //   },
// //   { to: '/resource-types', label: 'Resource Types' },
// //   { to: '/resources', label: 'Resources' },
// //   { to: '/resource-allocations', label: 'Resource Allocations' },
// // ];

// // // Helper function to create MenuItem links
// // const MenuItemLink = ({ to, label }) => (
// //   <MenuItem>
// //     <Link to={to}>{label}</Link>
// //   </MenuItem>
// // );

// // const SidebarMenu = () => {
// //   return (
// //     <div className='sidebar'>
// //       <ProSidebar>
// //         <div style={{ padding: '16px', fontSize: '20px', fontWeight: 'bold' }}>
// //           Event Management
// //         </div>
// //         <Menu iconShape='square'>
// //           {menuItems.map((item, index) =>
// //             item.items ? (
// //               <SubMenu key={index} title={item.title}>
// //                 {item.items.map((subItem, subIndex) => (
// //                   <MenuItemLink
// //                     key={subIndex}
// //                     to={subItem.to}
// //                     label={subItem.label}
// //                   />
// //                 ))}
// //               </SubMenu>
// //             ) : (
// //               <MenuItemLink key={index} to={item.to} label={item.label} />
// //             )
// //           )}
// //         </Menu>
// //       </ProSidebar>
// //     </div>
// //   );
// // };

// // export default SidebarMenu;

// // import CZIconLogo from 'assets/images/icons/czIconWhite.svg';
// // import CZLogo from 'assets/images/icons/czLogoWhite.svg';
// import * as _ from 'lodash';
// import React, { useState } from 'react';
// import { BsChevronLeft, BsChevronRight } from 'react-icons/bs';
// import {
//   Menu,
//   MenuItem,
//   ProSidebar,
//   SidebarContent,
//   SidebarFooter,
//   SidebarHeader,
//   SubMenu,
// } from 'react-pro-sidebar';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import menuLogo from '../assets/images/procam-logo.svg';

// const Sidebar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isCollapsed, setIsCollapsed] = useState(false);
//   const [isShowSidebar, setShowSidebar] = useState(false);

//   const sideMenuData = [
//     // {
//     //   label: 'Entities',
//     //   key: 'entities',
//     //   path: '/entities',
//     //   accessUser: [],
//     // },

//     {
//       label: 'Event',
//       key: 'event',
//       path: '/events',
//       icon: '',
//       accessUser: [],
//     },
//     {
//       label: 'Station',
//       key: 'department',
//       path: '/departments',
//       accessUser: [],
//     },
//     {
//       label: 'Event Stations',
//       key: 'eventDepartments',
//       path: '/eventDepartments',
//       icon: '',
//       accessUser: [],
//     },
//     {
//       label: 'Vendor',
//       key: 'vendor',
//       path: '/vendor',
//       accessUser: [],
//     },
//     {
//       label: 'Roles',
//       key: 'roles',
//       path: '/roles',
//       accessUser: [],
//     },
//     {
//       label: 'Users',
//       key: 'users',
//       path: '/users',
//       icon: '',
//       accessUser: [],
//     },
//     // {
//     //   label: 'Location',
//     //   key: 'location',
//     //   path: '/location',
//     //   accessUser: [],
//     // },
//     {
//       label: 'Item Types',
//       key: 'itemTypes',
//       path: '/items-type',
//       accessUser: [],
//     },
//     {
//       label: 'Items',
//       key: 'itemsList',
//       path: '/items',
//       accessUser: [],
//     },
//     // {
//     //   label: 'Inward Items',
//     //   key: 'event',
//     //   path: '/inward-items',
//     //   icon: '',
//     //   accessUser: [],
//     // },
//     {
//       label: 'Alloted Item',
//       key: 'allotedItem',
//       path: '/alloted-items',
//       icon: '',
//       accessUser: [],
//     },
//     {
//       label: 'Delivery Item',
//       key: 'event',
//       path: '/delivered-items',
//       icon: '',
//       accessUser: [],
//     },
//     {
//       label: 'Picked-up Item',
//       key: 'picked',
//       path: '/picked-up-items',
//       icon: '',
//       accessUser: [],
//     },
//     // {
//     //   label: 'Attendance',
//     //   key: 'attendances',
//     //   path: '/attendances',
//     //   icon: '',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Volunteers',
//     //   key: 'volunteers',
//     //   path: '/volunteers',
//     //   icon: '',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Reports',
//     //   key: 'reports',
//     //   icon: '',
//     //   accessUser: [],
//     //   children: [
//     //     {
//     //       label: 'Station Report',
//     //       key: 'stationReport',
//     //       path: '/stationReport',
//     //       accessUser: [],
//     //     },
//     //   ],
//     // },
//     // {
//     //   label: 'Events',
//     //   key: 'events',
//     //   path: '/events',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Permissions',
//     //   key: 'permissions',
//     //   path: '/permission',
//     //   icon: '',
//     //   accessUser: [],
//     // },

//     // {
//     //   label: 'Event Sections',
//     //   key: 'eventSections',
//     //   path: '/event-sections',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Station Type',
//     //   key: 'stations',
//     //   path: '/station-types',
//     //   icon: '',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Stations',
//     //   key: 'stations',
//     //   path: '/stations',
//     //   icon: '',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Resource Types',
//     //   key: 'resourceTypes',
//     //   path: '/resource-types',
//     //   icon: '',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Resources',
//     //   key: 'resources',
//     //   path: '/resources',
//     //   icon: '',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Resource Allocations',
//     //   key: 'resourceAllocations',
//     //   path: '/resource-allocations',
//     //   icon: '',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Attendance',
//     //   key: 'attendance',
//     //   path: '/attendance',
//     //   icon: '',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Item Types',
//     //   key: 'itemTypes',
//     //   path: '/items-type',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Items',
//     //   key: 'itemsList',
//     //   path: '/items',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Item Deliveries',
//     //   key: 'itemDeliveries',
//     //   path: '/item-deliveries',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Item Delivery Logs',
//     //   key: 'itemDeliveryLogs',
//     //   path: '/item-delivery-logs',
//     //   accessUser: [],
//     // },
//     // {
//     //   label: 'Ambulance Tracking map',
//     //   key: 'ambulanceTrackingMap',
//     //   path: '/ambulance-map',
//     //   accessUser: [],
//     // },
//   ];
//   // {
//   //   label: 'Entities',
//   //   key: 'entities',
//   //   icon: '',
//   //   accessUser: [],
//   //   children: [
//   //     {
//   //       label: 'Entities',
//   //       key: 'entities',
//   //       path: '/entities',
//   //       accessUser: [],
//   //     },
//   //     {
//   //       label: 'Events',
//   //       key: 'events',
//   //       path: '/events',
//   //       accessUser: [],
//   //     },
//   //     {
//   //       label: 'Event Sections',
//   //       key: 'eventSections',
//   //       path: '/event-sections',
//   //       accessUser: [],
//   //     },
//   //   ],
//   // },
//   // {
//   //   label: 'Users',
//   //   key: 'users',
//   //   path: '/users',
//   //   icon: '',
//   //   accessUser: [],
//   // },
//   // {
//   //   label: 'Permission Access',
//   //   key: 'roles',
//   //   icon: '',
//   //   accessUser: [],
//   //   children: [
//   //     {
//   //       label: 'Permissions',
//   //       key: 'permissions',
//   //       path: '/permission',
//   //       icon: '',
//   //       accessUser: [],
//   //     },
//   //     {
//   //       label: 'User Role Events',
//   //       key: 'userRoleEvents',
//   //       path: '-role-events',
//   //       icon: '',
//   //       accessUser: [],
//   //     },

//   //   ],
//   // },
//   // {
//   //   label: 'Items',
//   //   key: 'items',
//   //   icon: '',
//   //   accessUser: [],
//   //   children: [
//   //     {
//   //       label: 'Item Types',
//   //       key: 'itemTypes',
//   //       path: '/items-type',
//   //       accessUser: [],
//   //     },
//   //     {
//   //       label: 'Items',
//   //       key: 'itemsList',
//   //       path: '/items',
//   //       accessUser: [],
//   //     },
//   //     {
//   //       label: 'Item Deliveries',
//   //       key: 'itemDeliveries',
//   //       path: '/item-deliveries',
//   //       accessUser: [],
//   //     },
//   //     {
//   //       label: 'Item Delivery Logs',
//   //       key: 'itemDeliveryLogs',
//   //       path: '/item-delivery-logs',
//   //       accessUser: [],
//   //     },
//   //     {
//   //       label: 'Resource Types',
//   //       key: 'resourceTypes',
//   //       path: '/resource-types',
//   //       icon: '',
//   //       accessUser: [],
//   //     },
//   //     {
//   //       label: 'Resources',
//   //       key: 'resources',
//   //       path: '/resources',
//   //       icon: '',
//   //       accessUser: [],
//   //     },
//   //     {
//   //       label: 'Resource Allocations',
//   //       key: 'resourceAllocations',
//   //       path: '/resource-allocations',
//   //       icon: '',
//   //       accessUser: [],
//   //     },
//   //   ],
//   // },
//   // {
//   //   label: 'Resource',
//   //   key: 'resource',
//   //   icon: '',
//   //   accessUser: [],
//   //   children: [

//   //   ],
//   // },

//   const gotoPage = (item) => {
//     if (_.get(item, 'path') !== '') {
//       navigate(item.path);
//     }
//   };

//   const getActivePage = (currentPage, pageItem) => {
//     const currPageName = _.split(currentPage, '/')[1];
//     const itemPageName = _.split(pageItem, '/')[1];
//     return !!(currPageName && itemPageName && currPageName === itemPageName);
//   };

//   const getSideMenuByRole = (arrData, role) => {
//     return _.filter(arrData, (dataItem) => {
//       if (_.has(dataItem, 'accessUser')) {
//         return (
//           _.filter(dataItem.accessUser, (userRole) => userRole === role)
//             .length > 0
//         );
//       } else {
//         return dataItem;
//       }
//     });
//   };

//   const handleToggleSidebar = () => {
//     setShowSidebar(!isShowSidebar);
//   };

//   return (
//     <React.Fragment>
//       <aside className='sidebar-main'>
//         <ProSidebar
//           collapsed={isCollapsed}
//           className='react-sidebar__main'
//           breakPoint='md'
//           onToggle={handleToggleSidebar}
//         >
//           <SidebarHeader className='sidebar-header--block'>
//             <Link to='/'>
//               {isCollapsed ? (
//                 <div className='small-sidebar-logo__block'>
//                   <div className='small-logo--img'>
//                     {/* <img src={menuLogo} alt='' /> */}
//                   </div>
//                 </div>
//               ) : (
//                 <div className='sidebar__logo'>
//                   <div className='logo--img'>
//                   <img src={menuLogo} alt='' />
//                   </div>
//                 </div>
//               )}
//             </Link>
//           </SidebarHeader>
//           <SidebarContent className='sidebar-content--block scrollable'>
//             <Menu className='side-menu-bar'>
//               {_.map(sideMenuData, (item, index) => {
//                 const activeMenu = getActivePage(
//                   location.pathname,
//                   _.get(item, 'path')
//                 );
//                 let subMenuPage;
//                 if (item.children) {
//                   subMenuPage = _.find(item.children, {
//                     path: location.pathname,
//                   });
//                 }
//                 if (item?.children) {
//                   return (
//                     <SubMenu
//                       key={`sub-menu-${item.key}-${index}`}
//                       className='sidebar-menu-item sidebar-sub-menu-item'
//                       title={item.label}
//                       icon={item.icon}
//                       defaultOpen={isShowSidebar && subMenuPage}
//                     >
//                       {_.map(item.children, (subItem, subIndex) => {
//                         const activeSubMenu = getActivePage(
//                           location.pathname,
//                           _.get(subItem, 'path')
//                         );
//                         return subItem.children ? (
//                           <SubMenu
//                             key={`sub-menu-${subItem.key}-${subIndex}`}
//                             className='sub-menu-inner-menu-item'
//                             title={subItem.label}
//                             icon={subItem.icon}
//                             // defaultOpen={isShowSidebar && subMenuPage}
//                           >
//                             {_.map(subItem.children, (subItem, subIndex) => {
//                               const activeSubMenu = getActivePage(
//                                 location.pathname,
//                                 _.get(subItem, 'path')
//                               );
//                               return (
//                                 <MenuItem
//                                   key={`sub-menu-${subItem.key}-${subIndex}`}
//                                   className={`sidebar-menu-item ${
//                                     activeSubMenu ? 'active' : ''
//                                   }`}
//                                   onClick={() => gotoPage(subItem)}
//                                   style={{
//                                     color: activeMenu ? '#8649ff' : 'white',
//                                   }}
//                                 >
//                                   <Link to={subItem.path} target='_self'>
//                                     {subItem.label}
//                                   </Link>
//                                 </MenuItem>
//                               );
//                             })}
//                           </SubMenu>
//                         ) : (
//                           <MenuItem
//                             key={`sub-menu-${subItem.key}-${subIndex}`}
//                             className={`sidebar-menu-item ${
//                               activeSubMenu ? 'active' : ''
//                             }`}
//                             onClick={() => gotoPage(subItem)}
//                             style={{
//                               color: activeMenu ? '#8649ff' : 'white',
//                             }}
//                           >
//                             <Link to={subItem.path} target='_self'>
//                               {subItem.label}
//                             </Link>
//                           </MenuItem>
//                         );
//                       })}
//                     </SubMenu>
//                   );
//                 } else {
//                   return (
//                     <MenuItem
//                       key={`menu-${item.key}-${index}`}
//                       className={`sidebar-menu-item ${
//                         activeMenu ? 'active' : ''
//                       }`}
//                       icon={item.icon}
//                       onClick={() => gotoPage(item)}
//                     >
//                       <Link
//                         to={item.path}
//                         target='_self'
//                         style={{
//                           color: activeMenu ? '#8649ff' : 'white',
//                         }}
//                       >
//                         {item.label}
//                       </Link>
//                     </MenuItem>
//                   );
//                 }
//               })}
//             </Menu>
//           </SidebarContent>
//           <SidebarFooter className='sidebar-footer--block'>
//             <div className='sidebar-footer--block__inner'>
//               <span onClick={() => setIsCollapsed(!isCollapsed)}>
//                 {isCollapsed ? <BsChevronRight /> : <BsChevronLeft />}
//               </span>
//             </div>
//           </SidebarFooter>
//         </ProSidebar>
//       </aside>
//     </React.Fragment>
//   );
// };

// Sidebar.propTypes = {};

// export default Sidebar;

// // src/components/Sidebar.js
// import React from 'react';
// import { Menu, MenuItem, ProSidebar, SubMenu } from 'react-pro-sidebar';
// import { Link } from 'react-router-dom';

// // Menu data structure
// const menuItems = [
//   { to: '/', label: 'Home' },
//   {
//     title: 'Entities',
//     items: [
//       { to: '/entities', label: 'Entities' },
//       { to: '/events', label: 'Events' },
//       { to: '/event-sections', label: 'Event Sections' },
//     ],
//   },
//   {
//     title: 'Stations',
//     items: [
//       { to: '/station-types', label: 'Station Types' },
//       { to: '/stations', label: 'Stations' },
//     ],
//   },
//   { to: '/users', label: 'Users' },
//   { to: '/roles', label: 'Roles' },
//   { to: '/permissions', label: 'Permissions' },
//   { to: '-role-events', label: 'User Role Events' },
//   {
//     title: 'Items',
//     items: [
//       { to: '/items-type', label: 'Item Types' },
//       { to: '/items', label: 'Items' },
//       { to: '/item-deliveries', label: 'Item Deliveries' },
//       { to: '/item-delivery-logs', label: 'Item Delivery Logs' },
//     ],
//   },
//   { to: '/resource-types', label: 'Resource Types' },
//   { to: '/resources', label: 'Resources' },
//   { to: '/resource-allocations', label: 'Resource Allocations' },
// ];

// // Helper function to create MenuItem links
// const MenuItemLink = ({ to, label }) => (
//   <MenuItem>
//     <Link to={to}>{label}</Link>
//   </MenuItem>
// );

// const SidebarMenu = () => {
//   return (
//     <div className='sidebar'>
//       <ProSidebar>
//         <div style={{ padding: '16px', fontSize: '20px', fontWeight: 'bold' }}>
//           Event Management
//         </div>
//         <Menu iconShape='square'>
//           {menuItems.map((item, index) =>
//             item.items ? (
//               <SubMenu key={index} title={item.title}>
//                 {item.items.map((subItem, subIndex) => (
//                   <MenuItemLink
//                     key={subIndex}
//                     to={subItem.to}
//                     label={subItem.label}
//                   />
//                 ))}
//               </SubMenu>
//             ) : (
//               <MenuItemLink key={index} to={item.to} label={item.label} />
//             )
//           )}
//         </Menu>
//       </ProSidebar>
//     </div>
//   );
// };

// export default SidebarMenu;

// import CZIconLogo from 'assets/images/icons/czIconWhite.svg';
// import CZLogo from 'assets/images/icons/czLogoWhite.svg';
// import React, { useState } from 'react';
// import {
//   FaHome,
//   FaProjectDiagram,
//   FaUsers,
//   FaFolder,
//   FaCalendarAlt,
//   FaCog,
//   FaEnvelope,
//   FaUniversalAccess,
//   FaRegBuilding,
// } from 'react-icons/fa';
// import { Link, useLocation, useNavigate } from 'react-router-dom';
// import '../assets/css/style.css';
// import menuLogo from '../assets/images/procam-logo.svg';
// import { Fa500Px, FaBox, FaTag } from 'react-icons/fa'; // FontAwesome icons
// import { MdLocationCity, MdBusiness, MdShoppingCart } from 'react-icons/md'; // Material Design icons
// import { GiShipWheel, GiShoppingCart } from 'react-icons/gi'; // Other icon sets
// import { RxUpdate } from 'react-icons/rx';
// import { RiGpsFill } from 'react-icons/ri';

// const Sidebar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const [isCollapsed, setIsCollapsed] = useState(false);

//   // const sideMenuData = [
//   //   { label: 'Dashboard', path: '/dashboard', icon: <FaHome /> },
//   //   { label: 'Visual Attachments', path: '/attachments', icon: <FaFolder /> },
//   //   { label: 'Project Statistics', path: '/statistics', icon: <FaProjectDiagram /> },
//   //   { label: 'Team Members', path: '/team', icon: <FaUsers /> },
//   //   { label: 'Server Data', path: '/server-data', icon: <FaCalendarAlt /> },
//   //   { label: 'Folder Settings', path: '/settings', icon: <FaCog /> },
//   //   { label: 'Messages', path: '/messages', icon: <FaEnvelope /> },

//   // ];

//   const sideMenuData = [
//     {
//       label: 'Manage Event',
//       path: '/events',
//       icon: <Fa500Px />,
//     },
//     {
//       label: ' Manage Station',
//       path: '/departments',
//       icon: <MdLocationCity />,
//     },
//     {
//       label: 'Event Stations',
//       path: '/eventDepartments',
//       icon: <MdBusiness />,
//     },
//     // {
//     //   label: 'Vendor',
//     //   path: '/vendor',
//     //   icon: <FaBox />,
//     // },
//     {
//       label: ' Manage Roles',
//       path: '/roles',
//       icon: <FaTag />,
//     },
//     {
//       label: 'Manage Permissions',
//       path: '/permissions',
//       icon: <FaUniversalAccess />,
//     },
//     {
//       label: 'Manage Users',
//       path: '/users',
//       icon: <FaUsers />,
//     },
//     // Uncomment and update if needed
//     // {
//     //   label: 'Location',
//     //   path: '/location',
//     //   icon: <MdLocationCity />,
//     // },
//     {
//       label: 'Manage Product Types',
//       path: '/items-type',
//       icon: <GiShoppingCart />,
//     },
//     {
//       label: 'Product',
//       path: '/items',
//       icon: <GiShoppingCart />,
//     },
//     // {
//     //   label: 'Inward Items',
//     //   path: '/inward-items',
//     //   icon: <GiShoppingCart />,
//     // },
//     {
//       label: 'Alloted Item',
//       path: '/alloted-items',
//       icon: <GiShipWheel />,
//     },
//     {
//       label: 'Inward Delivery',
//       path: '/delivered-items',
//       icon: <GiShipWheel />,
//     },
//     {
//       label: 'Outward Picked-up ',
//       path: '/picked-up-items',
//       icon: <GiShipWheel />,
//     },
//     {
//       label: 'Station Update',
//       path: '/stationUpdate',
//       icon: <RxUpdate />,
//     },
//     {
//       label: 'GPS',
//       path: '/gpsUnits',
//       icon: <RiGpsFill />,
//     },

//     {
//       label: 'Station Report',
//       path: '/stationReport',
//       icon: <RiGpsFill />,
//     },
//     // {
//     //   label: 'Functional Depeartment',
//     //   path: '/functionalDepartments',
//     //   icon: <FaRegBuilding />,
//     // },
//     // {
//     //   label: 'Volunteers',
//     //   path: '/volunteers',
//     //   icon: <RiGpsFill />,
//     // },
//   ];

//   const handleNavigation = (path) => {
//     navigate(path);
//   };

//   return (
//     <div className={`sidebar-container ${isCollapsed ? 'collapsed' : ''}`}>
//       {/* Profile Section */}
//       <div className='sidebar-header'>
//         {/* <div className="profile-image"></div> */}
//         {!isCollapsed && (
//           <div className='profile-info'>
//             <img src={menuLogo} width='150' height='60' />
//           </div>
//         )}
//       </div>

//       {/* Navigation Menu */}
//       <div className='sidebar-menu'>
//         {sideMenuData.map((item, index) => (
//           <div
//             key={index}
//             className={`menu-item ${
//               location.pathname === item.path ? 'active' : ''
//             }`}
//             onClick={() => handleNavigation(item.path)}
//           >
//             <div className='menu-icon'>{item.icon}</div>
//             {!isCollapsed && <span className='menu-label'>{item.label}</span>}
//           </div>
//         ))}
//       </div>

//       {/* Toggle Button */}
//       <div className='sidebar-footer'>
//         <button
//           className='toggle-button'
//           onClick={() => setIsCollapsed(!isCollapsed)}
//         >
//           {isCollapsed ? '>' : '<'}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default Sidebar;

import React, { useEffect, useState } from 'react';
import {
  FaHome,
  FaProjectDiagram,
  FaUsers,
  FaFolder,
  FaCalendarAlt,
  FaCog,
  FaEnvelope,
  FaUniversalAccess,
  FaRegBuilding,
} from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import '../assets/css/style.css';
import menuLogo from '../assets/images/pro360.png';
import { Fa500Px, FaBox, FaTag } from 'react-icons/fa'; // FontAwesome icons
import {
  MdLocationCity,
  MdBusiness,
  MdShoppingCart,
  MdKeyboardArrowDown,
  MdKeyboardArrowUp,
  MdOutlineManageHistory,
  MdOutlineManageAccounts,
} from 'react-icons/md'; // Material Design icons
import { GiShipWheel, GiShoppingCart } from 'react-icons/gi'; // Other icon sets
import { RxUpdate } from 'react-icons/rx';
import { RiAdminFill, RiCalendarEventFill, RiGpsFill } from 'react-icons/ri';
import { IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { Typography } from '@mui/material';
import {
  difference,
  every,
  filter,
  includes,
  intersection,
  isEmpty,
  map,
} from 'lodash';
import { toast } from 'react-toastify';
import { FaFileInvoice } from 'react-icons/fa6';
import { TfiMenu } from 'react-icons/tfi';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [sidebarMenu, setSidebarMenu] = useState([]);
  const role = localStorage?.getItem('roles')
    ? JSON.parse(localStorage?.getItem('roles'))
    : [];
  const permissions = localStorage?.getItem('permissions')
    ? JSON.parse(localStorage?.getItem('permissions'))
    : [];
  // State to track open submenus
  const [openSubmenu, setOpenSubmenu] = useState(null);

  const sideMenuData = [
    // {
    //   label: 'Inward Items',
    //   path: '/inward-items',
    //   icon: <GiShoppingCart />,
    // },
    {
      label: 'Manage Qty',
      icon: <MdOutlineManageHistory />,
      hasSubmenu: true,
      roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
      // roles: ['CPANEL USER'],
      submenu: [
        {
          label: 'Inward Delivery',
          path: '/delivered-items',
          icon: <GiShipWheel />,
          roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
          // permission: 'DELIVERED ITEM',
          // roles: ['CPANEL USER'],
        },
        {
          label: 'Outward Picked-up ',
          path: '/picked-up-items',
          icon: <GiShipWheel />,
          roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
          // permission: 'PICKED-UP ITEM',
          // roles: ['CPANEL USER'],
        },
        // {
        //   label: 'Station Report',
        //   path: '/stationReport',
        //   icon: <RiGpsFill />,
        //   roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
        //   // roles: ['CPANEL USER'],
        // },
      ],
    },
    {
      label: 'Reports',
      icon: <FaFileInvoice />,
      hasSubmenu: true,
      roles: [
        'SUPER ADMIN',
        'ADMIN',
        'SUPERVISOR',
        'STATION MANAGER',
        'SYS ADMIN',
      ],
      // roles: ['CPANEL USER'],
      submenu: [
        {
          label: 'Delivery Report',
          path: '/stationReport',
          icon: <RxUpdate />,
          roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR', 'SYS ADMIN'],
          // permission: 'STATION',
          // roles: ['CPANEL USER', 'MANAGER'],
        },
        {
          label: 'Supervisor Updates',
          path: '/stationUpdate',
          icon: <RxUpdate />,
          roles: [
            'SUPER ADMIN',
            'ADMIN',
            'SUPERVISOR',
            'STATION MANAGER',
            'SYS ADMIN',
          ],
          // permission: 'STATION',
          // roles: ['CPANEL USER', 'MANAGER'],
        },
      ],
    },
    {
      label: 'GPS Units',
      path: '/gpsUnits',
      icon: <RiGpsFill />,
      roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR', 'COMMAND CENTER'],
      // permission: 'AMBULANCE MANAGER',
      // roles: ['CPANEL USER'],
    },
    {
      label: 'Settings',
      icon: <MdOutlineManageAccounts size={18} />,
      hasSubmenu: true, // Example of a submenu
      roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
      submenu: [
        {
          label: 'Manage Events',
          path: '/events',
          icon: <RiCalendarEventFill />,
          roles: ['SUPER ADMIN', 'ADMIN'],
        },
        // {
        //   label: 'Drop Off Points',
        //   path: '/departments',
        //   icon: <MdLocationCity />,
        //   roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
        // },
        // {
        //   label: 'Event Stations',
        //   path: '/eventDepartments',
        //   icon: <MdBusiness />,
        //   roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
        // },
        // {
        //   label: 'Vendor',
        //   path: '/vendor',
        //   icon: <FaBox />,
        // },
        // {
        //   label: ' Manage Roles',
        //   path: '/roles',
        //   icon: <FaTag />,
        // },
        // {
        //   label: 'Manage Permissions',
        //   path: '/permissions',
        //   icon: <FaUniversalAccess />,
        // },
        {
          label: 'Manage Products',
          path: '/items',
          icon: <GiShoppingCart />,
          roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
        },
        {
          label: 'Alloted Qty',
          path: '/alloted-items',
          icon: <GiShipWheel />,
          // permission: 'ALLOTED ITEM',
          roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
          // roles: ['CPANEL USER'],
        },
        {
          label: 'Location & Structure',
          path: '/location-structure',
          icon: <MdLocationCity />,
          roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
        },
        {
          label: 'Manage Users',
          path: '/users',
          icon: <FaUsers />,
          roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
        },
        // Uncomment and update if needed
        // {
        //   label: 'Location',
        //   path: '/location',
        //   icon: <MdLocationCity />,
        // },
        // {
        //   label: 'Manage Product Types',
        //   path: '/items-type',
        //   icon: <GiShoppingCart />,
        //   roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
        // },

        {
          label: 'About',
          path: '/about',
          icon: <GiShoppingCart />,
          roles: ['SUPER ADMIN', 'ADMIN', 'SUPERVISOR'],
        },
      ],
    },

    // {
    //   label: 'Functional Depeartment',
    //   path: '/functionalDepartments',
    //   icon: <FaRegBuilding />,
    // },
    // {
    //   label: 'Volunteers',
    //   path: '/volunteers',
    //   icon: <RiGpsFill />,
    // },
  ];

  // const filterMenuData = () => {
  //   const sideMenu = sideMenuData
  //     .map((item) => {
  //       if (includes(role, 'SUPER ADMIN')) {
  //         return item;
  //       }

  //       const hasValidRole =
  //         item.roles && item.roles.every((r) => includes(role, r));

  //       const hasPermission = permissions.some((perm) =>
  //         item.submenu
  //           ? item.submenu.some((subitem) => subitem.permission === perm)
  //           : item?.permission === perm
  //       );

  //       if (hasValidRole && hasPermission) {
  //         const filteredSubmenu = item.submenu
  //           ? item.submenu.filter((subitem) =>
  //               permissions.includes(subitem.permission)
  //             )
  //           : permissions.includes(item.permission);
  //         return {
  //           ...item,
  //           submenu: item.submenu ? filteredSubmenu : false,
  //         };
  //       }

  //       return null;
  //     })
  //     .filter(Boolean); // Remove null items

  //   if (!isEmpty(sideMenu)) {
  //     if (location?.pathname !== '/sidebar') {
  //       navigate(location?.pathname);
  //     } else if (sideMenu[0]?.submenu) {
  //       navigate(sideMenu[0]?.submenu?.map((data) => data?.path)[0]);
  //     } else {
  //       navigate(sideMenu[0]?.path);
  //     }
  //   } else {
  //     toast?.info('Sorry you do not have any permission to view any pages!!');
  //   }
  //   setSidebarMenu(sideMenu);
  // };

  // useEffect(() => {
  //   filterMenuData();
  // }, []);

  // const filterMenuData = () => {
  //   return sideMenuData
  //     .map((item) => {
  //       if (includes(role, 'SUPER_ADMIN') && item.label === 'Master') {
  //         return item;
  //       }
  //       if (

  //         permissions.some((perm) =>
  //           item.submenu
  //             ? item.submenu.some((subitem) => subitem.permission === perm)
  //             : item?.permission === perm
  //         )
  //       ) {
  //         const filteredSubmenu = item.submenu
  //           ? item.submenu.filter((subitem) =>
  //               permissions.includes(subitem.permission)
  //             )
  //           : permissions.includes(item.permission);

  //         return {
  //           ...item,
  //           submenu: filteredSubmenu,
  //         };
  //       }

  //       return null;
  //     })
  //     .filter(Boolean);
  // };

  const hasAllRoles = (menuRoles, userRoles) => {
    return every(userRoles, (role) => menuRoles.includes(role));
  };

  const filteredMenuData = map(
    sideMenuData.filter((menuItem) => {
      const hasAccessToMenu = hasAllRoles(menuItem.roles, role);

      if (menuItem.hasSubmenu) {
        const filteredSubmenu = menuItem.submenu.filter((submenuItem) =>
          hasAllRoles(submenuItem.roles, role)
        );

        return hasAccessToMenu && filteredSubmenu.length > 0;
      }

      return hasAccessToMenu;
    }),
    (data) => {
      if (data?.submenu) {
        return {
          ...data,
          submenu: filter(data?.submenu, (item) =>
            hasAllRoles(item?.roles, role)
          ),
        };
      } else {
        return data;
      }
    }
  );

  const handleNavigation = (path) => {
    navigate(path);
  };

  // Toggle submenu visibility
  const toggleSubmenu = (label) => {
    setOpenSubmenu(openSubmenu === label ? null : label);
  };

  return (
    <div className={`sidebar-container ${isCollapsed ? 'collapsed' : ''}`}>
      {/* Profile Section */}
      <div
        className='sidebar-header'
        style={{
          display: 'flex',
          justifyContent: isCollapsed ? 'center' : 'flex-start',
        }}
      >
        <div>
          <TfiMenu
            style={{ color: '#000' }}
            onClick={() => setIsCollapsed(!isCollapsed)}
            // onClick={() => setShowSidebar(false)}
            cursor='pointer'
          />
        </div>
        {!isCollapsed && (
          <div className='profile-info'>
            <img src={menuLogo} width='150' height='60' />
          </div>
        )}
        {/* <Typography>CPANEL</Typography> */}
      </div>

      {/* Navigation Menu */}
      <div className='sidebar-menu'>
        {filteredMenuData?.map((item, index) => (
          <div
            key={index}
            style={{
              paddingTop: role?.includes('COMMAND CENTER') ? '0.8rem' : 0,
            }}
          >
            <div
              className={`menu-item ${
                location.pathname === item.path ? 'active' : ''
              }`}
              onClick={(e) => {
                e.stopPropagation(); // Prevent triggering parent link
                toggleSubmenu(item.label);
                handleNavigation(item.path);
              }}
            >
              <div className='menu-icon'>{item.icon}</div>
              {!isCollapsed && (
                <span className='menu-label'>{item.label.toUpperCase()}</span>
              )}
              {item.hasSubmenu && (
                <span
                  className={`submenu-toggle ${
                    openSubmenu === item.label ? 'open' : ''
                  }`}
                >
                  {openSubmenu === item.label ? (
                    <IoIosArrowUp />
                  ) : (
                    <IoIosArrowDown />
                  )}
                </span>
              )}
            </div>

            {/* Submenu */}
            {item.hasSubmenu && openSubmenu === item.label && (
              <div className='submenu'>
                {item.submenu.map((subitem, subindex) => (
                  <div
                    key={subindex}
                    className={`submenu-item ${
                      location.pathname === subitem.path ? 'active' : ''
                    }`}
                    onClick={() => handleNavigation(subitem.path)}
                  >
                    <span className='submenu-label'>
                      {item?.label === 'Settings'
                        ? `${subindex + 1}. ${subitem.label.toUpperCase()}`
                        : subitem.label.toUpperCase()}
                    </span>
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Toggle Button */}
      {/* <div className='sidebar-footer'>
        <button
          className='toggle-button'
          onClick={() => setIsCollapsed(!isCollapsed)}
        >
          {isCollapsed ? '>' : '<'}
        </button>
      </div> */}
    </div>
  );
};

export default Sidebar;
